// children must implement class is-hidden

export class ElementToggleChild {
	root;

	selectors = {
		node: ".js-element-toggle-child",
		open: ".js-element-toggle-child__open",
		close: ".js-element-toggle-child__close",
		child: ".js-element-toggle-child__child",
	};

	constructor() {}

	init(rootSelector) {
		const self = this;

		self.root = document.querySelector(rootSelector || "body"); // fallback to whole document

		const elements = Array.prototype.slice.call(
			self.root.querySelectorAll(self.selectors.node)
		);

		elements.forEach(function (x) {
			self.bindToggle(x);
		});
	}

	bindToggle(_node) {
		const self = this;

		// get elements
		const open = _node.querySelector(self.selectors.open);
		const close = _node.querySelector(self.selectors.close);
		const child = _node.querySelector(self.selectors.child);

		if (!open || !close || !child) {
			return;
		}

		close.classList.add("u-hidden");
		child.classList.add("is-hidden");

		open.addEventListener("click", (e) => {
			open.classList.add("u-hidden");
			close.classList.remove("u-hidden");
			child.classList.remove("is-hidden");
		});

		close.addEventListener("click", (e) => {
			open.classList.remove("u-hidden");
			close.classList.add("u-hidden");
			child.classList.add("is-hidden");
		});
	}
}

window.ElementToggleChild = new ElementToggleChild();
window.ElementToggleChild.init();
